<template>
  <div id="app">
    <div class="content-section introduction" id="component">
      <div>
        <span class="feature-title">ProgressSpinner</span>
        <span>ProgressSpinnerDemo is a process status indicator.</span>
      </div>
    </div>
    <layout>
      <div id="wrapper">
        <h2>Features</h2>
        <h3>1. Basic</h3>
        <p>Progress of loading is displayed using basic spinner element</p>
        <vueui-progressSpinner></vueui-progressSpinner>
        <h3>2. Custom</h3>
        <p>The customized spinner with different colors with different percentages</p>
        <vueui-progressSpinner style="{width: '50px', height: '50px'}" strokeWidth="8" fill="#EEEEEE"
                               animationDuration=".5s"></vueui-progressSpinner>
      </div>
    </layout>
  </div>
</template>
<script>
  import Layout from "../layout";
  export default {
    name: 'progressspinnerdemo',
    components: {Layout},
    data: function () {
      return {
        value: 100
      }

    },
    methods: {
      back: function () {
        this.$router.go(-1);
      }
    }
  };
</script>




// WEBPACK FOOTER //
// showcase/src/components/progressspinner/progressspinnerdemo.vue